/**
* Timeline Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Timeline Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
// import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'timeline-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.timeline-callout' ).each( function( key, component ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 60%',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( component ).addClass( 'is-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              $( component ).addClass( 'is-animated' );
            },
            // markers: true,
          },
        } );
      } );

      $( '.timeline-callout .timeline-callout__mobile-item' ).each( function( key, item ) {
        const angleBar = $( item ).find( '.angle-bar--mobile' );
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( angleBar ).addClass( 'is-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              $( angleBar ).addClass( 'is-animated' );
            },
            // markers: true,
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'timeline-callout', COMPONENT );
} )( app );
